export enum VehicleType {
    Truck,
    Car,
}
